<app-header></app-header>
<div class="content">
  <div class="form-recharge">
    <form [formGroup]="form">
      <div class="main-title dashboard-title"><span>Dane do realizacji płatności</span></div>
      <div class="small75 progress-path">
        Wybór karty > Rejestracja w systemie > <b>Płatność</b>
      </div>
      <div class="description">
      <span class="body small75">
          Do wyboru masz następujące możliwości:
          <ul>
              <li>zapłacić kartą on-line (stripe)</li>
              <li>wykonać przelew tradycyjny, na podane niżej konto bankowe,</li>
          </ul>
      </span>
      </div>
      <div class="recharge-options">
        <div class="title">
          Płatność kartą
        </div>
        <br/>
        <div class="buttons" style='justify-content: center'>
          <button (click)="proceedWithCC()" [disabled]="paymentInProgress" type="submit">
            {{ paymentInProgress ? 'Trwa rejestracja i płatność...' : 'Zapłacę kartą kredytową / Blik / ApplePay / Google Pay' }}
          </button>
        </div>
        <div>
          <p class="small75"
             style='
                     margin-left: 225px;
                     margin-right: 30px;
                     margin-top: 0;
                     font-style: italic;
                     text-align: left;
                 '>
            Procedura rejestracji oraz nabycia karty SIM wraz z doładowaniem zostanie wstrzymana do
            czasu zaksięgowania płatności.
          </p>
        </div>
      </div>

      <div class="recharge-options">
        <div class="title">
          Dane do płatności przelewem
        </div>
        <hr/>
        <label for="seller">nazwa firmy</label>
        <input id="seller" maxLength="150" name="seller" readOnly type="text"
               value="SupraSAT IGNACY ZABOROWSKI"/><br/>
        <label for="bank">bank</label>
        <input id="bank" maxLength="150" name="bank" readOnly type="text"
               value="Bank Polska Kasa Opieki Spółka Akcyjna"/><br/>
        <label for="swift">KOD BIC/SWIFT</label>
        <input id="swift" maxLength="150" name="swift" readOnly type="text"
               value="PKOPPLPW"/><br/>
        <label for="iban">PLN</label>
        <input id="iban" maxLength="150" name="iban" readOnly type="text"
               value="87 1240 4416 1111 0010 8638 5753"/><br/>
        <label for="iban">USD</label>
        <input id="iban" maxLength="150" name="iban" readOnly type="text"
               value="32 1240 4416 1787 0010 8638 7281"/><br/>
        <label for="iban">EUR</label>
        <input id="iban" maxLength="150" name="iban" readOnly type="text"
               value="30 1240 4416 1978 0010 8638 6691"/><br/>
        <label for="reference">numer referencyjny</label>
        <input id="reference" maxLength="150" name="reference" readOnly type="text" value={{refNumber}}/><br/>

        <p class="small75"
           style='
                     margin-left: 225px;
                     margin-right: 30px;
                     margin-top: 0;
                     font-style: italic;
                     text-align: left;
                 '>
          Procedura rejestracji oraz nabycia karty SIM wraz z doładowaniem zostanie wstrzymana do
          czasu zaksięgowania płatności.<br/>
          Pamiętaj o podaniu numeru referencyjnego w celu szybszej identyfikacji wpłaty.
        </p>
        <div class="buttons" style='justify-content: space-between'>
          <button (click)="resetToRegister()" [disabled]="paymentInProgress" type="reset">Wróć</button>
          <button (click)="proceedWithBankTransfer()" [disabled]="paymentInProgress" type="submit">Zapłacę przelewem
          </button>
        </div>
      </div>
    </form>
    <footer class="content-footer">
      <img alt="logo" src="assets/parp-logo.jpg">
    </footer>
  </div>
</div>
